import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./HangingCard.css";

export default function HangingCard() {
  const navigate = useNavigate();

  return (
    <div className="hanging-card-wrapper">
      <span className="hanging-card__string" aria-hidden="true" />
      <motion.button
        type="button"
        className="hanging-card"
        onClick={() => navigate("/mba-tourism-management")}
        initial={{ rotate: -8, y: -60, opacity: 0 }}
        animate={{ rotate: [-6, 6, -6], y: 0, opacity: 1 }}
        transition={{
          y: { duration: 0.6, ease: "easeOut" },
          opacity: { duration: 0.6, ease: "easeOut" },
          rotate: { duration: 4, repeat: Infinity, ease: "easeInOut" },
        }}
        whileHover={{ scale: 1.06, rotate: 0 }}
        whileTap={{ scale: 0.96 }}
        aria-label="View Value Added Programmes"
      >
        <span className="hanging-card__clip" />
        <span className="hanging-card__badge">
          <span className="hanging-card__eyebrow">EXPLORE</span>
          <span className="hanging-card__title">VAP</span>
        </span>
      </motion.button>
    </div>
  );
}